import React from 'react';
import { t } from 'Utils/localization/i18next';
import styles from './AddressAutocomplete.module.scss';

export const AddressVendorMessage = () => (
  <div className={styles['address-autocomplete-option']}>
    {t('forms.addressVendorMessage')}
  </div>
);
